import companyList from '../data/companylistsearch.json';

const ACQUIRED_COMPANY_TICKERS = new Set(
  (companyList || [])
    .filter((company) => (
      company?.coverage === 'Acquired' &&
      !String(company?.ticker || '').toUpperCase().startsWith('PVT-')
    ))
    .map((company) => String(company.ticker).toUpperCase())
);

export const hasAcquisitionCompsheetByTicker = (candidateTicker) => (
  ACQUIRED_COMPANY_TICKERS.has(String(candidateTicker || '').toUpperCase())
);
